module.exports = "/_next/static/images/084c458bc9af80e0e61b30fec1572614-email-verification-success.jpg.webp";